import React, { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { notificationsSupported } from "../lib/notifications";

const DISMISS_KEY = "wl_notif_banner_dismissed";

// Banner discreto: appare solo dopo qualche secondo, mai al load immediato,
// e solo se il permesso browser è ancora "default" e non è stato già liquidato.
export const NotificationPermissionBanner = () => {
  const { user, setUser } = useAuth();
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!user || !notificationsSupported()) return undefined;
    if (Notification.permission !== "default") return undefined;
    if (localStorage.getItem(DISMISS_KEY) === "1") return undefined;
    const id = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(id);
  }, [user]);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const enable = async () => {
    setSaving(true);
    try {
      const res = await Notification.requestPermission();
      if (res === "granted") {
        const { data } = await api.patch("/me/notification-prefs", { desktop_notifications: true });
        setUser(data);
      }
    } catch {
      // silente
    } finally {
      setSaving(false);
      setVisible(false);
    }
  };

  return (
    <div
      data-testid="notification-permission-banner"
      className="bg-surface border-b border-border px-6 py-3 flex items-center gap-3"
    >
      <Bell size={16} strokeWidth={2} className="flex-shrink-0 text-text-secondary" />
      <div className="text-sm text-text-primary flex-1">
        Vuoi ricevere una notifica desktop quando arrivano nuovi messaggi o ticket mentre lavori su un&apos;altra finestra?
      </div>
      <button
        type="button"
        onClick={enable}
        disabled={saving}
        data-testid="notification-banner-enable"
        className="wl-btn wl-btn--primary wl-btn--sm"
      >
        {saving ? "Attivazione…" : "Attiva notifiche"}
      </button>
      <button
        type="button"
        onClick={dismiss}
        data-testid="notification-banner-dismiss"
        className="wl-btn wl-btn--ghost wl-btn--sm"
        aria-label="Non ora"
      >
        <X size={14} strokeWidth={2} />
        <span className="ml-1">Non ora</span>
      </button>
    </div>
  );
};
